import { connect } from "react-redux";
import HomePage from "./HomePage";
import { createSelector } from "redux-orm";
import { orm, dbStateSelector } from "db";
import {
    featureTeacherSelectorFnMaker,
    programSelectorFnMaker,
    selectTermsFromProgram
} from "./HomeSelectors";
import { homePageActionsCreator } from "./HomeAction";

const mapStateToProps = state => {
    const featureTeacherSelector = createSelector(
        orm,
        dbStateSelector,
        featureTeacherSelectorFnMaker()
    );
    let terms = [];
    const id = state.ui.home.activeProgram;
    if (id) {
        const programSelector = createSelector(
            orm,
            dbStateSelector,
            programSelectorFnMaker(id)
        );
        const program = programSelector(state);
        terms = selectTermsFromProgram(program);
    }

    return {
        terms: terms,
        featureTeachers: featureTeacherSelector(state),
        headerSlides: state.statics.headerSlides
    };
};

const mapDispatchToProps = dispatch => ({
    initData: () => {
        dispatch(homePageActionsCreator.getFeatureTeachersFromApi());
        dispatch(homePageActionsCreator.getActiveProgramFromApi());
    },
    buyProgram: programId => {
        if (programId) {
            dispatch(homePageActionsCreator.buyProgram(programId));
        } else {
            dispatch(homePageActionsCreator.buyActiveProgram());
        }
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomePage);
